module.exports = __webpack_public_path__ + "img/slide-1-md.9e7749c.webp";